import request from '@/utils/request'

const giftApiList = [
  // 获取待办
  ['getUpComingList', 'POST', '/api/saas/mobile/bpm/myTasks.do', 'params'],
  // ['getUpComingList', 'POST', '/mobile/bpm/myTasks.do?CurrentDomainName=zhaodan-it', 'params'],
  // 获取已办
  ['getCompleteList', 'POST', '/api/saas/mobile/bpm/myAttends.do', 'params'],
  // ['getCompleteList', 'POST', '/mobile/bpm/myAttends.do?CurrentDomainName=zhaodan-it', 'params'],
  // 获取待办详情
  ['getUpComingDetails', 'POST', '/api/saas/mobile/bpm/tasks/{id}.do', 'data', 'replace'],
  // ['getUpComingDetails', 'POST', '/mobile/bpm/tasks/{id}.do?CurrentDomainName=zhaodan-it', 'data', 'replace'],
  // 获取已办详情
  ['getCompleteDetails', 'GET', '/api/saas/mobile/bpm/attends/{id}.do', 'data', 'replace'],
  // ['getCompleteDetails', 'GET', '/mobile/bpm/attends/{id}.do?CurrentDomainName=zhaodan-it', 'data', 'replace'],
  // 获取预算详情
  ['getBudgetDetails', 'POST', '/api/saas/mobile/budget/info.do', 'params'],
  // 审批
  ['handleDoNext', 'POST', '/api/saas/mobile/bpm/doNext.do', 'data'],
  // 获取预算整体情况
  ['overallBudget', 'GET', '/mobile/budget/use.do', 'params'],
  // 审批记录
  ['getRecord', 'GET', '/api/saas/mobile/bpm/instances/{id}/histories.do', 'data', 'replace'],
  // 审批记录
  ['getComments', 'GET', '/api/saas/mobile/bpm/instances/{id}/comments.do', 'data', 'replace'],
  //相关协议
  ['getAgreements','POST','/api/saas/mobile/contract/agreements.do','params']
]

let apiListMap = giftApiList.reduce((sum, prev) => {
  if (!prev || !prev[0] || !prev[1]) return sum
  sum[prev[0]] = prev
  return sum
}, {})

export function fetchData (apiName, payload) {
  const api = apiListMap[apiName]
  let options
  if (api[4] === 'replace' && payload) {
    options = {
      url: api[2].replace('{id}', payload),
      method: api[1]
    }
  } else {
    options = {
      url: api[2],
      method: api[1]
    }
  }
  if (api[1] === 'GET' && api[4] !== 'replace' && payload) {
    options.params = payload
  }
  if (api[1] === 'POST' && payload) {
    if (api[3] !== 'params') {
      options.data = payload
    } else {
      options.params = payload
    }
  }
  return request(options)
}

